import React from 'react'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const UserMaster = React.lazy(() => import('./views/user-master/UserMaster'))
// const Colors = React.lazy(() => import('./views/theme/colors/Colors'))
// const Typography = React.lazy(() => import('./views/theme/typography/Typography'))
const URLAudit = React.lazy(() => import('./views/url-audit/UrlAudit'))
const AdminDashboard = React.lazy(() => import('./views/AdminDashboard'))

const licensing = React.lazy(() => import('./views/licensing'))

const UserManagement = React.lazy(() => import('./views/user-management/UserManagement'))

const FAQ = React.lazy(() => import('./views/faq/index'))
const Profile = React.lazy(() => import('./views/profile/Profile'))

const CompanyNotification = React.lazy(() => import('./views/profile/CompanyNotification'))

const MyDocuments = React.lazy(() => import('./views/pages/AIMyDocuments/AIMyDocuments'))


const routes = [
  { path: '/', exact: true, name: 'Home', routeName:'home'},
  { path: '/dashboard', name: 'Dashboard', element: Dashboard,  routeName:'Dashboard'},
  { path: '/user-insights', name: 'Administration', element: AdminDashboard,  routeName:'User Management'},
  { path: '/licensing', name: 'Licensing', element: licensing,  routeName:'Licensing'},
  { path: '/user-management', name: 'UserManagement', element: UserManagement,  routeName:'User Management'},
  { path: '/user-master', name: 'UserMaster', element: UserMaster,  routeName:'User Master'},
  { path: '/pages/AIMyDocuments', name: 'My Documents', element: MyDocuments, routeName:'My Documents' },
  { path: '/url-audit', name: 'URLAudit', element: URLAudit,  routeName:'URL Audit'},
  { path: '/faq', name: 'FAQ', element: FAQ,  routeName:'FAQ'},
  { path: '/profile', name: 'Profile', element: Profile,  routeName:'Profile'},
  
  { path: '/company-notification', name: 'CompanyNotification', element: CompanyNotification,  routeName:'Company Notification'},
]


export default routes
